import { useEffect, useState } from 'react';
import useEventListener from './useEventListener';  

const useScreenResizer=()=> {
  // State for storing viewsceen size, used by resize event listener below
  const [screenSize, setScreenSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  function screenResizeHandler(){
    var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;
    setScreenSize({ width: x, height: y });
  }

  // Add event listener using our custom hook found in the /app_suite/common.js file
  useEventListener('orientationchange', screenResizeHandler);
  useEventListener('resize', screenResizeHandler);
  useEffect(()=> {
    screenResizeHandler();  // Initialize width and height
    
  },[]);
  return {size: screenSize, setSize: setScreenSize}
}


export default useScreenResizer;


